(function() {
angular.module('app.ui.form.ctrls')
.controller('deleteMatterModalCtrl', [
    '$scope', '$http', '$log', '$modalInstance', '$location', 'data', '$translate', function($scope, $http, $log, $modalInstance, $location, data, $translate) {
      $scope.confirmAction = false;
      $scope.yes = function() {
        $scope.confirmAction = true;
        $modalInstance.close($scope.confirmAction);
      };
      $scope.no = function() {
        $modalInstance.dismiss("cancel");
      };
    }
  ]);
}());


// WEBPACK FOOTER //
// ./scripts/form/deleteMatterModalCtrl.js